import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { firstQueryValue } from '../../../util/queryParams';

function Failure() {
    const location = useLocation();
    const navigate = useNavigate();

    const { url, uid, payAmount, shippingCharge } = useMemo(() => {
        const parsed = queryString.parse(location.search);
        return {
            url: firstQueryValue(parsed.url),
            uid: firstQueryValue(parsed.uid),
            payAmount: parsed.payAmt ? firstQueryValue(parsed.payAmt) : '0',
            shippingCharge: parsed.shipAmt ? firstQueryValue(parsed.shipAmt) : '0',
        };
    }, [location.search]);

    const redirectToReward = useCallback(() => {
        const search =
            '?url=' +
            url +
            '&ath=true&uid=' +
            uid +
            '&totalAmount=' +
            payAmount +
            '&shippingCharge=' +
            shippingCharge;
        navigate({ pathname: '/pay', search }, { replace: true });
    }, [navigate, url, uid, payAmount, shippingCharge]);

    const shippingNum = shippingCharge ? parseInt(String(shippingCharge), 10) : 0;
    const payNum = payAmount ? parseInt(String(payAmount), 10) : 0;
    const amount = payNum + shippingNum;

    return (
        <div className="Card-container" style={{ background: 'white' }}>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                    <div className="card">
                        <div className="card-body cart-card">
                            <div className="cart-header">
                                <div className="flex-row" style={{ justifyContent: 'center' }}>
                                    <div className="card-text F1">Oops</div>
                                    <div className="card-text F1"></div>
                                </div>

                                <div className="flex-row" style={{ justifyContent: 'center' }}>
                                    <div className="card-text F3">Something went wrong, Try again later...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row Mb-3 Mb-B10 card paySuccess-card card-shadow-NA">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="" style={{ padding: '3em 0px' }}>
                        <div className="card-body no-Pd" style={{ textAlign: 'center' }}>
                            <svg className="cross" width="100" height="100" viewBox="0 0 100 100">
                                <circle className="cross-disc" cx="50" cy="50" r="48" stroke="#ef4e4f" strokeWidth="1" fill="#ff00001f"></circle>
                                <path
                                    className="cross-line"
                                    d="M65 33L35 66"
                                    fill="none"
                                    stroke="#ef4e4f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                                <path
                                    className="cross-line"
                                    d="M65 66L35 33"
                                    fill="none"
                                    stroke="#ef4e4f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                            </svg>

                            <div className="card-body card-Pd alignCen">
                                <h1 className="card-title payTxt">Payment Fail</h1>
                            </div>

                            <div className="card-body card-Pd alignCen">
                                <div className="card-text Fw F2">Your payment of Rs. {amount} has been failed</div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer>
                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ padding: '0px' }}>
                        <button type="submit" className="BuyBtnFooter red-btn" onClick={redirectToReward}>
                            OK
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    );
}

const mapStateToProps = (state: { pay: { transactionId: unknown; retailPrice: unknown }; verify: { isShare: boolean } }) => ({
    transactionId: state.pay.transactionId,
    retailPrice: state.pay.retailPrice,
    isShare: state.verify.isShare,
});

export default compose(connect(mapStateToProps))(Failure);
